import React from 'react';
import type PlanTimelineType from '@jira/spa-apps__advanced-roadmaps-plan-timeline/src/ExportedComponent.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Props } from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/main/tabs/roadmap/types.tsx';

/**
 * Plan Timeline page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanTimeline: LazyComponent<React.ComponentType<Props>> = lazyForPaint<
	typeof PlanTimelineType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-timeline", jiraSpaEntry: "async-plan-timeline" */ '@jira/spa-apps__advanced-roadmaps-plan-timeline/src/ExportedComponent.tsx'
			),
		),
	{ ssr: false },
);

const AsyncPlanTimeline = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanTimeline} pageId="plan-timeline" shouldShowSpinner />
);

export default AsyncPlanTimeline;
